module.exports = __webpack_public_path__ + "images/96d3e2d023ba50cfcc278e9bcc39ce14.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/swimandgoseek-miniposter.jpg
// module id = ./webpack/assets/img/swimandgoseek-miniposter.jpg
// module chunks = 0